import {AbstractControl, AsyncValidatorFn, FormGroup, ValidatorFn} from "@angular/forms";
import {EntityFormCollectionControl} from "./entity-form-collection-control";
import {EntityFormControl} from "./entity-form-control";

export class EntityFormGroup extends FormGroup {
    path: string;

    constructor(path: string, controls: { [p: string]: AbstractControl }, validator?: ValidatorFn | any, asyncValidator?: AsyncValidatorFn | any) {
        super(controls, validator, asyncValidator);
        this.path = path;
    }

    public findEntityFormControl(path: string): EntityFormControl {
        for (const key in this.controls) {
            const control: AbstractControl = this.controls[key];
            if (control instanceof EntityFormControl) {
                if (control.path === path || (control.path.startsWith(path + ".") && !(control instanceof EntityFormCollectionControl))) {
                    return control;
                }
            } else if (control instanceof EntityFormGroup) {
                if (control.path === path) {
                    for (const nestedKey in control.controls) {
                        const nestedControl: AbstractControl = control.controls[nestedKey];
                        if (nestedControl instanceof EntityFormControl) {
                            return nestedControl;
                        }
                    }
                }
                if (path.startsWith(control.path + ".")) {
                    const nestedControl = control.findEntityFormControl(path);
                    if (nestedControl) {
                        return nestedControl;
                    }
                }
            }
        }
        return undefined;
    }
}
